import closeSvg from 'public/icons/bulkupload/close.svg';
import bulkNudgeSvg from 'public/images/bulk-upload-nudge.svg';
import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styles from './styles.less';

export const HelperContent = ({ title, subtitle, desc, closeFunc }) => (
  <Fragment>
    <div className={styles.closeIcon} onClick={closeFunc}>
      <img src={closeSvg} alt="" />
    </div>
    <div className={styles.helperContent}>
      {title && <span className={styles.helperTitle}>{title}</span>}
      {subtitle && <span className={styles.helperSubtitle}>{subtitle}</span>}
      {desc && <span className={styles.helperDescription}>{desc}</span>}
    </div>
  </Fragment>
);

HelperContent.defaultProps = {
  subtitle: undefined,
};

HelperContent.propTypes = {
  title: PropTypes.string.isRequired,
  desc: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  closeFunc: PropTypes.func.isRequired,
};

export const NudgeBulkUploadContent = ({ title, desc }) => (
  <div className={styles.bulkNudge}>
    <div className={styles.nudgeContent}>
      <img src={bulkNudgeSvg} className={styles.nudgeImg} alt="" />
      <span className={styles.nudgeTitle}>{title}</span>
      <span className={styles.nudgeDescription}>{desc}</span>
    </div>
  </div>
);

NudgeBulkUploadContent.propTypes = {
  title: PropTypes.string.isRequired,
  desc: PropTypes.string.isRequired,
};

export default {};
